export const isValidNumber = (val: any): val is number => (val !== undefined && val !== null && !isNaN(val) && typeof (val) === typeof (1));